<template>
    <div>
        <div class="container">

            <div class="vld-parent" style="margin-left: auto; margin-right: auto;">
                <loading
                        :active.sync="open_loader"
                        :can-cancel="false"
                        :is-full-page="true"
                        :color="'red'"
                >
                </loading>
            </div>

            <div class="row">
                <div class=" col-md-6">
                    <div class="container" style="margin-top: 50px; color: white">
                        <div class="row" style="background-color: rgba(34, 31, 32, 0.83);">
                            <div class="col-md-12" style="margin: 50px; max-width: 80%">
                                <p class="h3" style="text-align: center;">
                                    <img src="@/img/navigation/login.png" style="width: 100px"> <br><br> <strong>PRIJAVA</strong>
                                    <br><br>
                                </p>
                                <p>
                                    <strong>Upišite E-mail adresu i poveznica za promjenu lozinke će vam biti poslana.</strong>
                                    <br><br>
                                </p>

                                <form class="form-horizontal">

                                    <div :class="{'form-group': true}">

                                        <label
                                                for="email"
                                                class="control-label"
                                        >
                                            E-Mail *
                                        </label>

                                        <input
                                                id="email"
                                                type="text"
                                                class="form-control text-danger"
                                                name="email"
                                                v-model="email"
                                                required
                                                autofocus
                                                style="color: black"
                                        >

                                        <span
                                                v-if="errors && errors.email"
                                                class="help-block"
                                        >
                                                <strong>
                                                    {{ errors.email[0] }}
                                                </strong>
                                            </span>

                                    </div>


                                    <div class="form-group">
                                        <div class="col-md-12" style="text-align: center">
                                            <button
                                                    type="submit"
                                                    class="btn btn-xl btn-secondary"
                                                    @click.prevent="forgot_password"
                                                    style="width: 80%"
                                            >
                                                <string>Pošalji</string>
                                            </button>


                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
name: "ForgotPassword",
    components: {
    Loading
    },
    data: function() {
        return {
            email: null,
            errors: null,
            open_loader: false,
        }
    },
    methods: {
        forgot_password(){
            let vm = this;
            vm.open_loader = true;
            axios.post(process.env.VUE_APP_API_URL + "forgot-password", {
                email: vm.email,
                password: vm.password
            })
                    .then(response => {
                        if( response.data.success ){
                            vm.$router.push( 'forgot-password-success' );
                        } else {
                            vm.errors = response.data.messages
                        }
                        vm.open_loader = false
                    })
                    .catch( function ( error ) {
                        if(error instanceof Error) {
                            console.log( 'Error: ' . error);
                        } else {
                            console.log( 'Unexpected response: ' . error);
                        }
                        vm.open_loader = false
                    } )
        }
    }
}
</script>

<style scoped>

</style>

<style lang="scss">
.vertical-scrollbar {
    width: 100%;
    height: calc(100vh - 200px);
    flex-grow: 1;
    article {
        padding: 15px;
    }
}
</style>